<app-platform-card *ngFor="let p of platforms" [data]="p"></app-platform-card>
